var FIGURE = FIGURE || {};

// The estate maps dialog on the Land page.
//
// A native <dialog> rather than a Bootstrap modal, so the top layer, the backdrop, the focus trap
// and Escape all come from the browser and the only things left to wire up are opening it and
// cycling the maps. Same shape as FIGURE.mobileNav, which is the site's other native dialog.
//
// Stepping is written as a modulo over however many maps the markup holds rather than as a two-state
// flip, so the maps the CMS may grow join the rotation on their own.
FIGURE.landMap = function () {
    var dialog = document.querySelector('[data-land-map]');
    var openBtn = document.querySelector('[data-land-map-open]');

    if (!dialog || !openBtn) return;

    var closeBtn = dialog.querySelector('[data-land-map-close]');
    // Two nodes each: the chevron beside the map and the invisible half of the map itself. Queried
    // as a set rather than singly so the pair stays one control as far as this file is concerned.
    var prevBtns = dialog.querySelectorAll('[data-land-map-prev]');
    var nextBtns = dialog.querySelectorAll('[data-land-map-next]');
    var images = dialog.querySelectorAll('[data-land-map-image]');
    var countEl = dialog.querySelector('[data-land-map-count]');
    var liveRegion = dialog.querySelector('[data-land-map-live]');
    var current = 0;

    // announce is off for the reset on open, where the dialog is about to read itself out anyway,
    // and on for every step the visitor takes.
    function show(index, announce) {
        current = index;
        images.forEach(function (img, i) {
            var active = i === index;
            img.classList.toggle('is-active', active);
            // Only the map on screen is described. Every map is in the dialog at once, so without
            // this a screen reader would read the whole set as a list of images on open.
            if (active) {
                img.removeAttribute('aria-hidden');
            } else {
                img.setAttribute('aria-hidden', 'true');
            }
        });

        // The template renders the opening 1/N, so this is only ever an update.
        if (countEl) countEl.textContent = (index + 1) + '/' + images.length;

        if (announce && liveRegion) {
            liveRegion.textContent = 'Map ' + (index + 1) + ' of ' + images.length;
        }
    }

    openBtn.addEventListener('click', function () {
        // Always opens on the first map. Reset here rather than on close, where the maps would be
        // seen swapping back through the dialog's fade-out.
        show(0, false);
        // Cleared with it, so a second visit does not still hold the last step of the first one —
        // the region is only ever written to by a move the visitor makes.
        if (liveRegion) liveRegion.textContent = '';
        dialog.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            dialog.close();
        });
    }

    // Both ends wrap, so neither arrow is ever dead — with five maps a visitor who overshoots the
    // last one gets the first back rather than a control that stops responding. The + length keeps
    // the step off the end negative-safe.
    function step(delta) {
        show((current + delta + images.length) % images.length, true);
    }

    if (images.length > 1) {
        prevBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                step(-1);
            });
        });

        nextBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                step(1);
            });
        });
    }

    // Dismiss on a click outside the maps. The dialog fills the viewport and centres the stage
    // inside it, so everything around the map is the dialog's own box and reports itself as the
    // target; anything on the map hits one of the two halves covering it, and the chevrons are
    // buttons of their own, so neither reaches here.
    dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
    });

    // Fires for every route out — Escape and the backdrop included, not just the close button.
    dialog.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
    });
}();
